<nz-space nzDirection="vertical" style="width: 100%">
  <nz-space-item>
    <div class="upload-section">
      <input #fileUploader nz-input type="file" accept=".csv,.txt,.xlsx" style="display: none" [ngModel]="attachedFile"
        (change)="handleChange($event)" />
      <div class="uploadArea" style="border: 1px dashed black;background-color: rgba(48, 46, 92, 0.06);" (click)="fileUploader.click()">
        <nz-space nzDirection="vertical" style="text-align: center; width: 100%">
          <nz-space-item>
            <i class="fal fa-inbox-out" style="font-size: 41px; color: rgb(48 46 92)"></i>
          </nz-space-item>
          <nz-space-item>
            {{ "Click to upload file" | locale }}
          </nz-space-item>
          <nz-space-item>
            <span nz-typography nzType="secondary">
              {{"Only one file can be uploaded, accepted file types: text, csv or excel" | locale}}
            </span>
          </nz-space-item>
        </nz-space>
      </div>
    </div>
  </nz-space-item>
</nz-space>
